import "./FacilityUserViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import FacilityUserViewComponent from "./facility-user-view/FacilityUserViewComponent";
import FacilityUserEditComponent from "./facility-user-edit/FacilityUserEditComponent";

interface FacilityUserViewEditComponentProps {
    facilityDetails: any
    onUpdateAdminDetails: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const FacilityUserViewEditComponent = (props: FacilityUserViewEditComponentProps) => {
    const {facilityDetails, onModeChange, canEdit, onUpdateAdminDetails} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");

    const handlePhysicianDetailsUpdate = useCallback((updatedUserDetailsList: any) => {
        onUpdateAdminDetails((prev: any) => {
            return {
                ...prev,
                userDetails: updatedUserDetailsList
            }
        })
    }, [onUpdateAdminDetails]);

    const handlePhysicianDetailsEditCancel = useCallback((updatedUserDetailsList: any) => {
        onUpdateAdminDetails((prev: any) => {
            return {
                ...prev,
                userDetails: updatedUserDetailsList
            }
        })
        setMode("view");
    }, [onUpdateAdminDetails]);

    useEffect(() => {
        onModeChange(mode);
    }, [mode, onModeChange]);
    return (
        <div className={'facility-user-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <FacilityUserViewComponent
                    userList={facilityDetails?.userDetails || []}
                    facilityId={facilityDetails.id}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                    onUpdateComplete={handlePhysicianDetailsUpdate}
                />
            }
            {
                mode === "edit" && <FacilityUserEditComponent
                    userDetailsList={facilityDetails?.userDetails || []}
                    facilityId={facilityDetails.id}
                    onUpdateComplete={handlePhysicianDetailsUpdate}
                    onEditCancel={handlePhysicianDetailsEditCancel}
                />
            }
        </div>
    );

};

export default FacilityUserViewEditComponent;
